import React from 'react';
import { SearchImportBar, ImportResultModal, LoadingBar } from '../../../components/common';
import { ImportResult } from './types';
import '../../../components/common/CRMForm.css';
import './CrsDataImportForm.css';

interface CrsAbsenteeMergeImportFormProps {
  absenteeFile: File | null;
  propertyFile: File | null;
  onSelectAbsentee: (file: File | null) => void;
  onSelectProperty: (file: File | null) => void;
  onImport: () => void;
  importResult: ImportResult | null;
  onCloseResult: () => void;
  error: string | null;
  globalLoading: boolean;
  loadingMessage: string;
}

const CrsAbsenteeMergeImportForm: React.FC<CrsAbsenteeMergeImportFormProps> = ({
  absenteeFile,
  propertyFile,
  onSelectAbsentee,
  onSelectProperty,
  onImport,
  importResult,
  onCloseResult,
  error,
  globalLoading,
  loadingMessage
}) => {
  const canImport = Boolean(absenteeFile && propertyFile) && !globalLoading;

  return (
    <>
      <div className="form">
        <div className="form-header">
          <h2>CRS Data Absentee Merge Import</h2>
        </div>
        <p>
          Upload an Absentee Owner CSV and a Property Location CSV.
          Rows are correlated by Owner Name. Each match creates or reuses a Prospect
          with a primary mailing address and a rental address.
        </p>

        <div className="app-form-group">
          <label className="app-form-label" htmlFor="crs-absentee-file">Absentee Owner CSV</label>
          <div className="crs-data-import-picker">
            <SearchImportBar
              accept=".csv,text/csv"
              loading={globalLoading}
              title="Choose Absentee Owner CSV"
              onImport={(file) => onSelectAbsentee(file)}
            />
            <span id="crs-absentee-file">{absenteeFile ? absenteeFile.name : 'No file selected'}</span>
          </div>
        </div>

        <div className="app-form-group">
          <label className="app-form-label" htmlFor="crs-property-file">Property Location CSV</label>
          <div className="crs-data-import-picker">
            <SearchImportBar
              accept=".csv,text/csv"
              loading={globalLoading}
              title="Choose Property Location CSV"
              onImport={(file) => onSelectProperty(file)}
            />
            <span id="crs-property-file">{propertyFile ? propertyFile.name : 'No file selected'}</span>
          </div>
        </div>

        <div className="app-form-actions">
          <button
            type="button"
            className="app-btn app-btn-primary"
            onClick={onImport}
            disabled={!canImport}
          >
            Import
          </button>
        </div>

        {error && <div className="app-error-message">{error}</div>}
      </div>
      <ImportResultModal
        isOpen={importResult !== null}
        processed={importResult?.processed || 0}
        notProcessed={importResult?.notProcessed || []}
        onClose={onCloseResult}
      />
      <LoadingBar isLoading={globalLoading} message={loadingMessage} />
    </>
  );
};

export default CrsAbsenteeMergeImportForm;
